import React, { useEffect, useRef, useState } from "react";
import { ShieldCheck, RefreshCw } from "lucide-react";

interface CaptchaProps {
  setCaptchaVerified: (value: boolean) => void;
}
const generateCaptcha = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

  return Array.from({ length: 4 }, () =>
    chars[Math.floor(Math.random() * chars.length)]
  ).join("");
};
const Captcha: React.FC<CaptchaProps> = ({ setCaptchaVerified }) => {
  const [captchaCode, setCaptchaCode] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
const checkCaptcha = (value:any) => {
    setCaptchaInput(value);

    if (value.toUpperCase() === captchaCode) {
      setCaptchaVerified(true);
    } else {
      setCaptchaVerified(false);
    }
  };

  const refreshCaptcha = () => {
    setCaptchaCode(generateCaptcha());
    setCaptchaInput("");
    setCaptchaVerified(false);
  };
  return (
    <div className="flex items-center gap-4">
      <div
        className="w-24 h-full bg-surface-variant rounded-xl flex items-center justify-center cursor-pointer hover:bg-surface-dim transition-colors group relative overflow-hidden border border-vibrant-orange/20"
        title="تحديث الرمز"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-tertiary-fixed-dim/20 to-transparent" />
        <span
          className="font-headline-md text-headline-md text-on-surface-variant tracking-[0.2em] relative z-10 select-none text-vibrant-orange"
          style={{ fontFamily: "monospace" }}
        >
          {captchaCode}
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-surface-container-highest/80 opacity-0 group-hover:opacity-100 transition-opacity z-20 backdrop-blur-[2px]">
          <span className="material-symbols-outlined text-on-surface">
            refresh
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2 bg-gray-100 rounded-2xl px-4 py-3">
        <input
          type="text"
          value={captchaInput}
        onChange={(e) => checkCaptcha(e.target.value)}
        placeholder="أدخل رمز التحقق"
        maxLength={4} 
          className="bg-transparent outline-none text-center tracking-[4px] w-24"
        />

        {/* <ShieldCheck
          onClick={verify}
          className="cursor-pointer text-gray-500 hover:text-green-600"
        /> */}

        <RefreshCw
           onClick={refreshCaptcha}
          className="cursor-pointer text-gray-500 hover:text-orange-500"
        />
      </div>
    </div>
  );
};

export default Captcha;
